import {Directive, ElementRef} from '@angular/core';
import payment from "payment";

@Directive({
  selector: '[creditCardNumber]'
})
export class CreditCardNumberDirective {

  constructor(private el: ElementRef) {
    const element = this.el.nativeElement;

    payment.formatCardNumber(element);
  }

}
